import { ChangeEventHandler, FC, FocusEventHandler } from 'react';

interface RadioButtonProps {
  name: string;
  title: string;
  value: string;
  checked: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onBlur: FocusEventHandler<HTMLInputElement>;
}

const RadioButton: FC<RadioButtonProps> = (props) => {
  const { name, title, value, checked, onChange, onBlur } = props;
  const circleColor = checked ? '#106c3a' : '#FFFFFF';
  const backgroundColor = checked ? '#EDF5D7' : '#FFFFFF';

  return (
    <label
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor,
        padding: '16px',
        cursor: 'pointer',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '18px',
          height: '18px',
          border: '1px solid #999',
          borderRadius: '50%',
          marginRight: '10px',
        }}
      >
        <span
          style={{
            display: checked ? 'block' : 'none',
            width: '14px',
            height: '14px',
            borderRadius: '50%',
            borderColor: circleColor,
            backgroundColor: circleColor,
          }}
        />
      </div>
      <span>{title}</span>
      <input
        name={name}
        value={value}
        checked={checked}
        type="radio"
        onChange={onChange}
        onBlur={onBlur}
        style={{ display: 'none' }}
      />
    </label>
  );
};

export default RadioButton;
